import FormUpload, { FileData } from './FormUpload';

export default FormUpload;
export type { FileData };
